<template>
  <div>
    <a-dropdown v-if="permission" :trigger="['click']">
      <span class="edit-priority">
        <a-tag v-if="casePremiums[value]" :color="casePremiums[value].color">{{ casePremiums[value].label }}</a-tag>
        <span v-else>--</span>
        <a-icon class="icon-down" type="down" />
      </span>
      <a-menu slot="overlay">
        <a-menu-item v-for="(item, key) in casePremiums" :key="key" v-tc="{ name: '变更优质用例', label: item.label }" @click="onChange(item.value)">
          <a-tag :color="item.color"> {{ item.label }} </a-tag>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <span v-else>
      <a-badge v-if="casePremiums[value]" :color="casePremiums[value].color" :text="casePremiums[value].label" />
      <span v-else>--</span>
    </span>
  </div>
</template>
<script>
import { casePremiums } from '@/utils/dictionary';
import { caseUpdateItem } from '@/api/project/case';
import { permissionRequired } from '@/utils/utils';

export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    caseId: {
      type: [String, Number],
      default: null
    },
    // eslint-disable-next-line vue/prop-name-casing
    project_id: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      casePremiums
    };
  },
  computed: {
    permission() {
      return permissionRequired('project:case:edit', this.projectId) || true;
    },
    projectId() {
      return parseInt(this.$route.params.project_id) || this.project_id;
    }
  },
  methods: {
    onChange(value) {
      caseUpdateItem({
        id: this.caseId,
        project_id: this.projectId,
        key: 'premium',
        value: value
      }).then(() => {
        this.isEdit = false;
        this.$message.success('更新成功');
        this.$emit('change');
      });
    }
  }
};
</script>

<style lang="less" scoped>
.edit-priority {
  cursor: pointer;
  display: inline-block;
  padding: 0 2px;
  line-height: 22px;
  .icon-down {
    opacity: 0;
  }
}
.edit-priority:hover {
  cursor: pointer;
  background-color: #e4e4e4;
  .icon-down {
    opacity: 1;
  }
}
/deep/.ant-tag {
  margin-right: 0;
}
</style>
